const LOCATION_EQUIPMENT_NAME_REGEX = /^[a-zA-Z0-9.\\+#: _,()&"'-]+$/;
export function locationEquipmentNameValid(name, usedNames) {
  if (!name) return false;
  if (usedNames.includes(name)) return false;
  return LOCATION_EQUIPMENT_NAME_REGEX.test(name);
}

const DEPLOYMENT_NAME_REGEX = /^[a-zA-Z0-9_/ -]+$/;

export function deploymentNameValid(name) {
  if (!name) return false;
  return DEPLOYMENT_NAME_REGEX.test(name);
}
